import ContactUsPage from "@/components/contact-us/ContactUsPage";
import NotFound from "@/components/common/NotFound";
import { isCommunityPortal } from "@/utils/type";

const ContactUs = ({ type }) => {
    return isCommunityPortal(type) ? <ContactUsPage /> : <NotFound />;
};

export async function getStaticProps() {
    return { props: { type: process.env.NEXT_PUBLIC_TYPE } };
}

export default ContactUs;
